/**
 * Aide à distinguer primaire et secondaire à partir du nom de la classe.
 *
 * En base les classes du secondaire sont "Collège" / "Lycée", mais on
 * rencontre aussi des libellés saisis autrement ("6e", "3ème", "Terminale").
 */
const normalize = (value) =>
  String(value ?? "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[\s.'’-]/g, "");

const SECONDAIRE_TESTS = [
  (value) => value.includes("college"),
  (value) => value.includes("lycee"),
  (value) => /(^|\D)[3-6]e(me)?($|\D)/.test(value), // 6e, 5eme, HV3eme...
  (value) => /(^|\D)(2nde|seconde|1ere|premiere)($|\D)/.test(value),
  (value) => /(^|\D)(terminale|tle)($|\D)/.test(value),
];

/**
 * @returns {boolean} true si la classe relève du collège ou du lycée.
 * Renvoie false quand la classe est inconnue (on reste sur le cas primaire).
 */
export const isSecondaire = (classe) => {
  const value = normalize(classe);
  if (!value) return false;
  return SECONDAIRE_TESTS.some((test) => test(value));
};

export default isSecondaire;
